import React, { useEffect, Fragment, useState } from 'react';
import { Button, Row, Col, Form, message, Upload, Space, Typography } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { dummyRequest, getFileName, uploadFileV2 } from 'Features/utility';
import { useForm } from 'react-hook-form';
import { LoadingOutlined } from '@ant-design/icons';
import placeholderImg from "Assets/img/product-placeholder.png"
import { useTranslate } from 'Translate';
import { updateEinvoice } from '../../../../../ducks/services';

const _ = require('lodash');
const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const { id, editOrganization, meta, data, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const [fileList, setFileList] = useState([]);
  const [fileId, setFileId] = useState();
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      name: 'tin',
      label: t("System.tin"),
      req: true,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'brn',
      label: t("System.brn"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'msic_code',
      label: t("System.msic_code"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'msic_desc',
      label: t("System.msic_desc"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'phoneno',
      label: t("System.phoneno"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'email',
      label: t("System.email"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      email: true,
      static: !allowedEdit
    },
    {
      name: 'address1',
      label: t("System.address1"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'address2',
      label: t("System.address2"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'city',
      label: t("System.city"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'postcode',
      label: t("System.postcode"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'state_code',
      label: t("System.state_code"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'account_number',
      label: t("System.account_number"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'payment_means_code',
      label: t("System.payment_means_code"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'payment_means_desc',
      label: t("System.payment_means_desc"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      setValue("tin", data.tin)
      setValue("brn", data.brn)
      setValue("msic_code", data.msic_code)
      setValue("msic_desc", data.msic_desc)
      setValue("phoneno", data.phoneno)
      setValue("email", data.email)
      setValue("address1", data.address1)
      setValue("address2", data.address2)
      setValue("city", data.city)
      setValue("postcode", data.postcode)
      setValue("state_code", data.state_code)
      setValue("account_number", data.account_number)
      setValue("payment_means_code", data.payment_means_code)
      setValue("payment_means_desc", data.payment_means_desc)
    }
  }, [data]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      ...val,
      id: id
    }

    await updateEinvoice(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_entity"));
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Row gutter={[20, 30]}>
          {formFields.map((item, idx) => (
            <Fragment key={idx}>
              {item?.subheader && (
                <Col span={24}>
                  <Title className="mb-0" level={4}>
                    <u>{item.subheader}</u>
                  </Title>
                </Col>
              )}
              <FormGroup item={item} control={control} errors={errors} />
            </Fragment>
          ))}
          {
            allowedEdit &&
            <Col span={24} className='text-right'>
              <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
            </Col>
          }
        </Row>
      </Form>
    </>
  )
}